import React from "react";
import FormDataProvider from "integrations/contexts/FormDataProvider";
import { toGenericInputCreateRequest } from "./formDataAdapter";
import Graph from "./Graph";
import INITIAL_FORMDATA from "./_initialFormData";
import { AdvancedOptionsProvider } from "../common/context/AdvancedOptions";
import { SidebarProvider } from "../common/context/Sidebar";
import { StepsProvider } from "../common/context/Steps";
const EmbeddedGraphApp = ({ onSubmit = null }) => {
  const handleSubmit = (formData) => {
    if (!onSubmit) {
      return;
    }
    onSubmit(toGenericInputCreateRequest(formData));
  };
  return /* @__PURE__ */ React.createElement(StepsProvider, null, /* @__PURE__ */ React.createElement(FormDataProvider, { initialFormData: INITIAL_FORMDATA }, /* @__PURE__ */ React.createElement(SidebarProvider, null, /* @__PURE__ */ React.createElement(AdvancedOptionsProvider, null, /* @__PURE__ */ React.createElement(Graph, { onSubmit: handleSubmit, externalInputSubmit: typeof onSubmit === "function" })))));
};
export default EmbeddedGraphApp;
